import { cx } from '@hrworks/design-system/functions';

import { S } from './AlertBody.styles';
import type { AlertBodyProps } from './AlertBody.types';

export const AlertBody = ({ className, ...otherProps }: AlertBodyProps) => (
  <S.InnerWrapper className={cx(S.cls.InnerWrapper, className)} {...otherProps} />
);
